export default __webpack_public_path__ + "static/2-9409ab07508d6a5a9f3bdf0a1b14e43d.png";